import { MindmapGrid } from '../../../components/Dashboard/styles/MindmapTableStyles'
import { SkeletonProjectCard } from './SkeletonProjectCard'

interface SkeletonProjectGridProps {
  count?: number
}

export function SkeletonProjectGrid({ count = 9 }: SkeletonProjectGridProps) {
  return (
    <MindmapGrid className="mindmap-grid">
      {Array.from({ length: count }, (_, i) => (
        <SkeletonProjectCard key={i} />
      ))}
    </MindmapGrid>
  )
}
